import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismMetricBlock } from '@mylighthouse/prism-ember';
import { ICONS_LOGOS_MAP } from '@mylighthouse/prism-logo';
import { t } from 'ember-intl';
import { FocusScreen } from 'frontend-utils';
import SmartCompsetBuilderReviewIllustration from 'lumen/assets/images/benchmark-insight/smart-compset/beni-smart-compset-builder-review.svg?raw';
import HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooter from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/smart-compset-builder/smart-compset-builder-footer';
import HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderHeader from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/smart-compset-builder/smart-compset-builder-header';
import HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderInfo from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/smart-compset-builder/smart-compset-builder-info';
import type HotelSettingsCompetitorsBenchmarkSmartCompsetReviewController from 'lumen/controllers/hotel/settings/competitors/benchmark/smart-compset/review';

interface HotelSettingsCompetitorsBenchmarkSmartCompsetReviewSignature {
  Args: {
    controller: HotelSettingsCompetitorsBenchmarkSmartCompsetReviewController;
    model: unknown;
  };
}

<template>
  <FocusScreen
    @hasCancel={{true}}
    @isCancelDisabled={{false}}
    @logoHtml={{ICONS_LOGOS_MAP.logo-dark-with-text}}
    @onClose={{@controller.onCloseModal}}
    @size="large"
  >
    <:header>
      <HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderHeader
        @currentStep={{3}}
      />
    </:header>

    <:body>
      <div class="smart-compset__builder__body">
        <div class="smart-compset__builder__body__left">
          <HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderInfo
            @imageHtml={{SmartCompsetBuilderReviewIllustration}}
            @subTitle={{t
              "benchmark-insight.smart-compset.smart-compset-builder.sub-title.review"
            }}
            @title={{t
              "benchmark-insight.smart-compset.smart-compset-builder.title.review"
            }}
          />
        </div>
        <div class="smart-compset__builder__body__right">
          <div class="smart-compset__builder__body__right__content">
            <div
              class="smart-compset__builder__body__right__content__review flex flex-row"
            >
              {{#each @controller.enabledCategories as |category|}}
                <PrismMetricBlock
                  @align="left"
                  class="smart-compset__builder__body__right__content__review__category"
                >
                  <:value>
                    <span class="text-400--bold">
                      {{category.formattedName}}
                    </span>
                  </:value>
                  <:label>{{category.formattedWeight}}</:label>
                </PrismMetricBlock>
              {{/each}}
            </div>
          </div>
        </div>
      </div>
    </:body>

    <:footer>
      <HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooter
      >

        <span class="smart-compset__builder__footer--back">
          <PrismButton
            @buttonType="ghost"
            @iconBefore="arrow-left"
            @label={{t "general.back"}}
            @onClick={{@controller.onBack}}
          />
        </span>

        <span class="smart-compset__builder__footer--continue">
          <PrismButton
            @buttonType="brand"
            @iconAfter="arrow-right"
            @label={{t "general.continue"}}
            @onClick={{@controller.onContinue}}
            data-test-id="smart-compset-review-button-continue"
          />
        </span>
      </HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooter>
    </:footer>
  </FocusScreen>
</template> satisfies TOC<HotelSettingsCompetitorsBenchmarkSmartCompsetReviewSignature>;
